exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "header .v-toolbar__content{width:auto}.v-application .elevation-1{border:0;webkit-box-shadow:none!important;-webkit-box-shadow:none!important;box-shadow:none!important}.v-input--selection-controls .v-input__slot>.v-label,.v-input--selection-controls .v-radio>.v-label{font-size:12px}.v-input--selection-controls.v-input{margin-bottom:-4px}.auth-provider,.auto-posting-frequency input[type=number]{text-align:center}.auth-provider{width:45%;padding:10px;background:rgba(25,35,58,.02)}.auth-provider.connected{background:rgba(36,119,246,.05)}", ""]);

// exports
